import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import WhyChoose from "../components/WhyChoose";
import CatchphraseBanner from "../components/CatchphraseBanner";
import Services from "../components/Services";
import PriceSheet from "../components/PriceSheet";
import About from "../components/About";
import Reviews from "../components/Reviews";
import ServiceArea from "../components/ServiceArea";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import CallStickyButton from "../components/CallStickyButton";

const Home = () => {
  return (
    <div className="text-left">
      <Header />
      <main>
        <Hero />
        <WhyChoose />
        <CatchphraseBanner />
        <Services />
        <PriceSheet />
        <About />
        <Reviews />
        <ServiceArea />
        <Contact />
      </main>
      <Footer />
      <CallStickyButton />
    </div>
  );
};

export default Home;
